import { render, staticRenderFns } from "./ArtworkItem.vue?vue&type=template&id=1d6e521e&scoped=true&"
import script from "./ArtworkItem.vue?vue&type=script&lang=js&"
export * from "./ArtworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkItem.vue?vue&type=style&index=0&id=1d6e521e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e521e",
  null
  
)

export default component.exports